module.exports = __webpack_public_path__ + "static/media/custom_publishing_1_A.a8dd217e.png";